<template>
    <v-card stretch>
        <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
            <v-text type="headline">
                Расход по тарифу
            </v-text>
        </div>

        <div v-if="profileTariff.title" v-padding.left="3" v-padding.right="3" v-padding.top="1" v-padding.bottom="4">
            <v-row>
                <v-col xs="3">
                    <tariff-card title="Тарифный план">
                        {{ profileTariff.title }}
                    </tariff-card>
                </v-col>

                <v-col xs="3">
                    <tariff-card title="Срок действия плана">
                        c {{ moment(profileTariff.startDate).format('DD.MM.YYYY') }}
                        <br />
                        до {{ moment(profileTariff.endDate).format('DD.MM.YYYY') }}
                    </tariff-card>
                </v-col>

                <v-col xs="3">
                    <tariff-card title="До окончания срока действия плана">
                        {{ profileTariff.daysLeft }} {{ labelDays(profileTariff.daysLeft) }}
                    </tariff-card>
                </v-col>
            </v-row>
        </div>

        <div v-padding="3">
            <close-tariff @closed="$emit('tariff-closed')" :btnIsDisabled="btnIsDisabled(products)" />
        </div>

        <div v-padding.bottom="3">
            <v-data-table
                    empty="Вы пока не сделали ни одного запроса"
                    :loader="loading"
                    @sort="$emit('sort', $event)"
                    :sort="sort"
                    :headers="headers"
                    :records="history"
            >
                <template slot="cell-title" scope="props">
                    <v-text>
                        {{ props.item.title }}
                    </v-text>
                </template>
                <template slot="cell-cost" scope="props">
                    <v-text>
                        {{ props.item.cost }}
                    </v-text>
                </template>
                <template slot="cell-ordersCount" scope="props">
                    <v-text>
                        {{ props.item.ordersCount }}
                    </v-text>
                </template>
                <template slot="cell-total" scope="props">
                    <v-text>
                        {{ props.item.ordersCount * props.item.cost }}
                    </v-text>
                </template>
            </v-data-table>
        </div>
    </v-card>
</template>
<script>
    import moment from 'moment';
    import { TariffCard } from '../tariffCard';
    import { numberWithSpaces, declOfNum } from '../../../helpers';
    import CloseTariff from "../requestProducts/CloseTariffContainer.vue";

    export default {
        name: 'tariff-history',
        props: {
            loading: Boolean,
            sort: Object,
            history: Array,
            profileTariff: Object,
            products: Array
        },
        data() {
            return {
                headers: {
                    title: { label: 'Продукт' },
                    cost: { label: 'Стоимость' },
                    ordersCount: { label: 'Заказов' },
                    total: { label: 'На сумму' },
                },
                selectedProduct: null
            }
        },
        components: {
            TariffCard,
            CloseTariff
        },
        methods: {
            numberWithSpaces,
            moment,
            labelDays(daysLeft) {
                return declOfNum(daysLeft, [
                    'день',
                    'дня',
                    'дней',
                ]);
            },
            btnIsDisabled(products) {
                const maxProducCost = Math.max(...products.map(p=> p.cost), 0);
                return !!this.profileTariff.balance && this.profileTariff.balance > maxProducCost
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TariffHistory.vue?54fe119b